<template>
    <div id='Sidebar'>
        <!--<div class='SidebarBackdrop' @click='closeSidebarPanel' v-if='isPanelOpen'></div> -->
        <transition name='slide'>
            <div class='SidebarPanel'>
                <div class='SidebarTop'>
                    <MenuItem
                        v-for='(menuItem, index) in menuList'
                        :key='index'
                        :path='menuItem.path'
                        :title='menuItem.title'
                        :icon='menuItem.icon'
                        :isOpen='isPanelOpen'
                     />
                </div>
                <div class='SidebarBottom'>
                     <MenuItem
                        title='Account Settings'
                        icon='AccountSettingsIcon'
                        :isOpen='isPanelOpen'
                     />
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
    import MenuItem from './MenuItem.vue'
    export default {
        name: 'Sidebar',
        props:['menuList', 'navOpen'],
        components: {
            MenuItem
        },
        computed: {
            isPanelOpen() {
                return this.$props.navOpen
            }
        }
    }
</script>
